import Step from "./Step";

class StepType extends Step {
    constructor() {
        super(4, 'business_type', $(`[data-register-step="business_type"]`));
        this.cards = this.element.find('.business-type-card');
        this.continueButton = this.element.find('#business_type_continue');
    }

    init() {
        console.log('StepType init: Retail or horeca');
        this.attachEventHandlers();
    }

    attachEventHandlers() {
        this.cards.off('click').on('click', (e) => {
            $(e.currentTarget).toggleClass('selected');
            this.continueButton.prop('disabled', this.selectedTypes().length === 0);
        });

        this.continueButton.off('click').on('click', async () => {
            const selected = this.selectedTypes();
            if (!selected.length) {
                return;
            }
            const businessType = selected.length === 2 ? 'both' : selected[0];

            this.continueButton.attr('data-kt-indicator', 'on').prop('disabled', true);

            try {
                await API.post("/register/saveStep", {
                    step: 4,
                    data: { business_type: businessType },
                });
                this.goNext();
            } catch (error) {
                console.error('StepType: Failed to save business type', error);
                message.error('Er is een fout opgetreden. Probeer het opnieuw.');
                this.continueButton.prop('disabled', false);
            } finally {
                this.continueButton.attr('data-kt-indicator', 'off');
            }
        });
    }

    selectedTypes() {
        return this.cards.filter('.selected').map((_, el) => $(el).data('business-type')).get();
    }
}

export default StepType;
